import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider } from "@/context/AuthContext";
import ProtectedRoute from "@/components/ProtectedRoute";
import Login from "@/pages/Login";
import Dashboard from "@/pages/Dashboard";
import Compliances from "@/pages/Compliances";
import Excise from "@/pages/Excise";
import Users from "@/pages/Users";
import Reminders from "@/pages/Reminders";
import Clients from "@/pages/Clients";
import ProCompliances from "@/pages/ProCompliances";
import AdditionalCompliances from "@/pages/AdditionalCompliances";
import AuditAndOtherCompliance from "@/pages/AuditAndOtherCompliance";
import CorporateTax from "@/pages/CorporateTax";
import { Toaster } from "@/components/ui/sonner";

const ADMIN_ROLES = ["administrator"];

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/login" element={<Login />} />
            <Route path="/dashboard" element={<ProtectedRoute><Dashboard /></ProtectedRoute>} />
            <Route path="/compliances" element={<ProtectedRoute><Compliances /></ProtectedRoute>} />
            <Route path="/excise" element={<ProtectedRoute><Excise /></ProtectedRoute>} />
            <Route path="/pro-compliances" element={<ProtectedRoute><ProCompliances /></ProtectedRoute>} />
            <Route path="/audit-compliance" element={<ProtectedRoute><AuditAndOtherCompliance /></ProtectedRoute>} />
            <Route path="/corporate-tax" element={<ProtectedRoute><CorporateTax /></ProtectedRoute>} />
            <Route path="/additional-compliances" element={<ProtectedRoute><AdditionalCompliances /></ProtectedRoute>} />
            <Route path="/clients" element={<ProtectedRoute><Clients /></ProtectedRoute>} />
            <Route path="/reminders" element={<ProtectedRoute><Reminders /></ProtectedRoute>} />
            <Route path="/users" element={<ProtectedRoute roles={ADMIN_ROLES}><Users /></ProtectedRoute>} />
            <Route path="/" element={<Navigate to="/dashboard" replace />} />
            <Route path="*" element={<Navigate to="/dashboard" replace />} />
          </Routes>
        </BrowserRouter>
        <Toaster position="bottom-right" richColors />
      </AuthProvider>
    </div>
  );
}

export default App;
